import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { FormBuilder, FormGroup } from "@angular/forms";
import lodash from "lodash";
import { EletronicFence } from "../../models/EletronicFence.model";
import { Company } from "../../models/Company.model";
import { ApiService } from "../../services/api.service";
import { ApiBaseService } from "../../services/migrate/api.base.service";
import { Validation } from "./validation";
import { NgxSpinnerService } from "ngx-spinner";
import storageX from "../../storageCore/storageX";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "../../storageCore/constStorageKeys";
import { ThemePalette } from "@angular/material/core";
import { MatSelectChange } from "@angular/material/select";

export interface Task {
  name: string;
  completed: boolean;
  color: ThemePalette;
  subtasks?: Task[];
  idEmpresa: number;
  idTerminal?: number;
}

@Component({
  selector: "app-create-eletronicFence",
  templateUrl: "./form.component.html",
  styleUrls: ["./form.component.scss"],
})
export class EditEletronicFenceComponent implements OnInit {
  public eletronicFenceForm: FormGroup;
  public eletronicFence: EletronicFence;
  public eletronicFenceId: number;
  public title = "Atualizar Cerca Eletrônica";
  public errorMessage;
  private service: ApiService;
  private validation: Validation;
  public vehicles = [];

  public empresaSelected;
  public empresaRegistrada: any = null;
  public empresasAuxiliares: any[] = [];
  public companyId;

  public company: any = [];
  public errorDebug;
  public companyForm;

  private linkedTerminalIds: number[] = [];

  constructor(
    private apiService: ApiService,
    private serviceApiBase: ApiBaseService,
    private formBuilder: FormBuilder,
    private router: Router,
    private spinner: NgxSpinnerService,
    public activatedRoute: ActivatedRoute
  ) {
    this.service = apiService;
    this.validation = new Validation();
  }

  task: Task = {
    name: "Todos",
    completed: false,
    color: "primary",
    subtasks: [],
    idEmpresa: 0,
  };
  markers = [];

  ngOnInit(): void {
    this.eletronicFenceForm = this.formBuilder.group(this.validation.rules());
    this.eletronicFenceId = this.activatedRoute.snapshot.params["id"];

    this.loadEletronicFence(this.eletronicFenceId);
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async setup(): Promise<void> {
    this.fillUserData();
    await this.loadCompanies();
    this.initSelectedCompanies();
  }

  public orgKind(item: any): string {
    if (this.isDivisao(item)) {
      return "Divisão";
    }
    if (item.idEmpresaMatriz != null || item.empresaMatriz != null) {
      return "Filial";
    }
    return "Matriz";
  }

  public isDivisao(item: any): boolean {
    if (!item) {
      return false;
    }
    if (item.tipo === "divisao") {
      return true;
    }
    return item.cnpj == null || item.cnpj === "";
  }

  public compareCompanies = (a: any, b: any): boolean => {
    return (
      a &&
      b &&
      Number(a.id) === Number(b.id) &&
      this.isDivisao(a) === this.isDivisao(b)
    );
  };

  private orgKey(item: any): string {
    const tipo = this.isDivisao(item) ? "d" : "e";
    return `${tipo}-${item.id}`;
  }

  private orgsParaFiltro(): any[] {
    const orgs = [];
    if (this.empresaRegistrada) {
      orgs.push(this.empresaRegistrada);
    }
    (this.empresasAuxiliares || []).forEach((item) => {
      if (!orgs.some((atual) => this.compareCompanies(atual, item))) {
        orgs.push(item);
      }
    });
    return orgs;
  }

  public get empresasAuxiliaresDisponiveis(): any[] {
    return (this.company || []).filter(
      (item) => !this.compareCompanies(item, this.empresaRegistrada)
    );
  }

  private resolveCompany(item: any): any {
    if (!item || item.id == null) {
      return null;
    }
    const resolved =
      (this.company || []).find((atual) => this.compareCompanies(atual, item)) ||
      item;
    if (
      !(this.company || []).some((atual) => this.compareCompanies(atual, item))
    ) {
      this.company = [...(this.company || []), resolved];
    }
    return resolved;
  }

  private addEmpresaAuxiliar(item: any): void {
    const resolved = this.resolveCompany(item);
    if (!resolved || this.compareCompanies(resolved, this.empresaRegistrada)) {
      return;
    }
    if (this.empresasAuxiliares.some((atual) => this.orgKey(atual) === this.orgKey(resolved))) {
      return;
    }
    this.empresasAuxiliares = [...this.empresasAuxiliares, resolved];
  }

  public onEmpresaRegistradaChange(event: MatSelectChange): void {
    this.empresaRegistrada = event.value || null;
    this.empresasAuxiliares = (this.empresasAuxiliares || []).filter(
      (item) => !this.compareCompanies(item, this.empresaRegistrada)
    );
    this.syncEmpresaControl();
    this.loadMarkersFilter();
  }

  public onAuxiliaresChange(event: MatSelectChange): void {
    this.empresasAuxiliares = event.value || [];
    this.loadMarkersFilter();
  }

  fillUserData(): void {
    const fields = [
      "nmNome",
      "nrVelocidadeAlarmePainel",
      "nrVelocidadeAlarmeVeiculo",
    ];

    fields.forEach((element) => {
      this.eletronicFenceForm.controls[element].setValue(
        this.eletronicFence[element]
      );
    });
  }

  private syncEmpresaControl(): void {
    const principal = this.empresaRegistrada;
    this.empresaSelected = principal ? principal.id : null;
    this.eletronicFenceForm.controls["empresa"].setValue(
      this.empresaSelected || ""
    );
  }

  private initSelectedCompanies(): void {
    this.empresaRegistrada = null;
    this.empresasAuxiliares = [];
    if (this.eletronicFence.divisao?.id) {
      const divisao = this.eletronicFence.divisao as any;
      this.empresaRegistrada = this.resolveCompany({
        id: divisao.id,
        nome: divisao.nome || divisao.nmNome,
        cnpj: null,
        tipo: "divisao",
      });
    } else if (this.eletronicFence.empresa?.id) {
      const empresa = this.eletronicFence.empresa;
      this.empresaRegistrada = this.resolveCompany({
        id: empresa.id,
        nome: empresa.nmNome,
        cnpj: empresa.cdCnpj || "-",
        idEmpresaMatriz: empresa.empresaMatriz,
        tipo: "empresa",
      });
    }
    this.syncEmpresaControl();
  }

  private mergeEmpresasFromTerminals(positions: any[]): void {
    (positions || []).forEach((position) => {
      const idDivisao = position.id_divisao ?? position.idDivisao;
      const nomeDivisao = position.nome_divisao ?? position.nomeDivisao;
      const idEmpresa = position.id_empresa ?? position.idEmpresa;
      const nomeEmpresa = position.nome_empresa ?? position.nomeEmpresa;

      if (idDivisao) {
        this.addEmpresaAuxiliar({
          id: idDivisao,
          nome: nomeDivisao,
          cnpj: null,
          tipo: "divisao",
        });
      }
      if (idEmpresa) {
        this.addEmpresaAuxiliar({
          id: idEmpresa,
          nome: nomeEmpresa,
          cnpj: "-",
          tipo: "empresa",
        });
      }
    });
  }

  private async loadCompanies(): Promise<void> {
    const result = await this.serviceApiBase.get<any>({
      url: new Company()["nomeConsultaApiBaseGetAll"],
      params: {
        size: 999999,
        page: 0,
        profileId: storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(),
      },
    });
    this.company = result?.content || [];
  }

  public async loadEletronicFence(id): Promise<void> {
    try {
      this.spinner.show();
      const response = await this.service.get({
        url: `cerca-eletronica/${id}`,
      });
      this.eletronicFence = response as EletronicFence;
      this.linkedTerminalIds = (
        this.eletronicFence.terminalCercaEletronicaList || []
      )
        .map((item) => item.idTerminal)
        .filter((terminalId) => !!terminalId)
        .map((terminalId) => Number(terminalId));
      await this.setup();
      await this.hydrateOrgsFromLinkedTerminals();
      await this.loadMarkersFilter(this.linkedTerminalIds);
    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitForm(): Promise<void> {
    try {
      this.spinner.show();
      const values = this.eletronicFenceForm.value;
      const id = Math.floor(this.eletronicFenceId);

      const elements = !this.empresaRegistrada ? [] : this.selectedTerminalIds();
      const isDivisao = this.isDivisao(this.empresaRegistrada);
      this.empresaSelected = this.empresaRegistrada
        ? this.empresaRegistrada.id
        : null;

      const post = {
        id,
        nmNome: values.nmNome,
        nrVelocidadeAlarmePainel: values.nrVelocidadeAlarmePainel,
        nrVelocidadeAlarmeVeiculo: values.nrVelocidadeAlarmeVeiculo,
        empresa: !this.empresaRegistrada || isDivisao
          ? null
          : {
              id: this.empresaRegistrada.id,
              cdCnpj:
                this.empresaRegistrada.cnpj ||
                this.empresaRegistrada.cdCnpj,
            },
        divisao: this.empresaRegistrada && isDivisao
          ? {
              id: this.empresaRegistrada.id,
            }
          : null,
        dsPosicoes: this.eletronicFence.dsPosicoes,
        cercaEletronicaTipo: this.eletronicFence.cercaEletronicaTipo,
        cercaEletronicaLocalProcessamento:
          this.eletronicFence.cercaEletronicaLocalProcessamento,
        ativo: true,
        terminalCercaEletronicaList: elements.map((element) => {
          return {
            idTerminal: element,
          };
        }),
        idUsuarioAlteracao: storageX
          .whereKeyIs(STORAGE_KEY_CURRENT_USER)
          .get()?.id,
      };

      console.log(post);

      await this.service.put<EletronicFence>(
        this.eletronicFenceId,
        "cerca-eletronica",
        post
      );

      this.spinner.hide();
      this.router.navigate(["/eletronic-fences"]);
    } catch (error) {
      this.spinner.hide();
      this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  listaDePlacas = new Array<any>();
  eletric_fence_payload = new Array();
  allComplete: boolean = false;

  private selectedTerminalIds(): number[] {
    return Array.from(
      new Set(
        (this.listaDePlacas || [])
          .filter((item) => item.completed && item.idTerminal)
          .map((item) => Number(item.idTerminal))
          .filter((terminalId) => terminalId > 0)
      )
    );
  }

  private syncListaDePlacas(subtask: Task): void {
    const placa = (this.listaDePlacas || []).find(
      (item) => Number(item.idTerminal) === Number(subtask.idTerminal)
    );
    if (placa) {
      placa.completed = subtask.completed;
    }
  }

  public onTerminalToggle(subtask: Task): void {
    this.syncListaDePlacas(subtask);
    this.updateAllComplete();
  }

  public updateAllComplete() {
    this.allComplete =
      this.task.subtasks != null &&
      this.task.subtasks.length > 0 &&
      this.task.subtasks.every((t) => t.completed);
  }

  public someComplete(): boolean {
    if (this.task.subtasks == null) {
      return false;
    }
    return (
      this.task.subtasks.filter((t) => t.completed).length > 0 &&
      !this.allComplete
    );
  }

  public setAll(completed: boolean) {
    this.allComplete = completed;
    if (this.task.subtasks == null) {
      return;
    }
    this.task.subtasks.forEach((t) => {
      t.completed = completed;
      this.syncListaDePlacas(t);
    });
  }

  public handleFilter(event: string) {
    let query = "";

    if (event) {
      query = event.toLocaleUpperCase();
    }

    this.task.subtasks = this.listaDePlacas.filter(({ name }) =>
      name.match(new RegExp("(" + query + ")"))
    );
  }

  // public async loadMarkers(): Promise<void> {
  //   try {
  //     const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get(); //localStorage.getItem('idPerfil');
  //     if (!perfil) {
  //       throw new Error("Nenhum perfil encontrado");
  //     }
  //     const url = `posicao-atual-terminal/perfil/${perfil}`;
  //     const source = await this.apiService.get<any[]>({
  //       url,
  //     });

  //     if (!source) {
  //       throw new Error("Nenhum result encontrado");
  //     }

  //     const result = this.buildPosicaoAtualTerminalList(source);

  //     result.forEach((e) => {
  //       this.task.subtasks.push({
  //         name: e.placa,
  //         completed: false,
  //         color: "primary",
  //       });
  //       this.listaDePlacas.push({
  //         name: e.placa,
  //         completed: false,
  //         color: "primary",
  //       });
  //     });

  //     this.markers = result;

  //     this.eletronicFence.terminalCercaEletronicaList.forEach((action) => {
  //       const itens = this.task.subtasks;

  //       itens.forEach((action2) => {
  //         const { idTerminal } = this.markers.find(
  //           (x) => x.placa == action2.name
  //         );
  //         if (idTerminal == action.idTerminal) {
  //           action2.completed = true;
  //         }
  //       });
  //     });
  //   } catch (error) {
  //     console.error(error);
  //   }
  // }

  private async hydrateOrgsFromLinkedTerminals(): Promise<void> {
    if (!this.linkedTerminalIds.length) {
      return;
    }
    const source =
      (await this.apiService.post<any[]>(
        "posicao-atual-terminal/terminais",
        this.linkedTerminalIds
      )) || [];
    this.mergeEmpresasFromTerminals(source);
  }

  public async loadMarkersFilter(keepIds?: number[]): Promise<void> {
    try {
      const keep = new Set(
        (keepIds && keepIds.length
          ? keepIds
          : (this.task.subtasks || [])
              .filter((item) => item.completed && item.idTerminal)
              .map((item) => item.idTerminal)
        )
          .filter((id) => !!id)
          .map((id) => Number(id))
      );

      this.task.subtasks = [];
      this.listaDePlacas = [];
      this.markers = [];
      this.allComplete = false;

      const selecionadas = this.orgsParaFiltro();
      if (!selecionadas.length) {
        this.spinner.hide();
        return;
      }

      this.spinner.show();
      const idsEmpresa = selecionadas
        .filter((item) => !this.isDivisao(item))
        .map((item) => Number(item.id));
      const idsDivisao = selecionadas
        .filter((item) => this.isDivisao(item))
        .map((item) => Number(item.id));

      const [porEmpresa, porDivisao] = await Promise.all([
        idsEmpresa.length
          ? this.apiService.post<any[]>(
              "posicao-atual-terminal/empresas-divisoes",
              { idsEmpresa, idsDivisao: [] }
            )
          : Promise.resolve([]),
        idsDivisao.length
          ? this.apiService.post<any[]>(
              "posicao-atual-terminal/empresas-divisoes",
              { idsEmpresa: [], idsDivisao }
            )
          : Promise.resolve([]),
      ]);

      const unique = new Map();
      [...(porEmpresa || []), ...(porDivisao || [])].forEach((item) => {
        if (item && item.id_terminal && !unique.has(item.id_terminal)) {
          unique.set(item.id_terminal, item);
        }
      });
      const source = Array.from(unique.values());

      source.forEach((e) => {
        const idTerminal = e.id_terminal;
        const task = {
          name: e.placa,
          completed: keep.has(Number(idTerminal)),
          color: "primary" as ThemePalette,
          idEmpresa: e.id_empresa || e.id_divisao,
          idTerminal,
        };
        this.task.subtasks.push(task);
        this.listaDePlacas.push(task);
      });

      this.markers = source;
      this.updateAllComplete();
      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error(error);
    }
  }

  private buildPosicaoAtualTerminalList(source: Array<any>): Array<any> {
    const items = source.map((e) => e.posicaoAtualTerminalList);

    const itemsChildren = source
      .map((value) => value.children.map((e) => e.posicaoAtualTerminalList))
      .flat();

    const itemsChildrenInChildren = source
      .map((value) => value.children.map((e) => e.children))
      .flat();

    itemsChildrenInChildren.forEach((e) => {
      if (e.length > 0) {
        e.forEach((element) => {
          itemsChildren.push(element.posicaoAtualTerminalList);
        });
      }
    });

    return lodash.flattenDeep([...items, ...itemsChildren]);
  }
}
